var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7346 21.3397V17.4423C18.7346 16.702 19.0449 15.9922 19.5945 15.4827L23.8537 11.5201C24.0488 11.3372 24.0488 11.0367 23.8537 10.8538L12.3169 0.124106C12.1352 -0.0413686 11.856 -0.0413686 11.6742 0.124106L5.69529 5.67621C5.4205 5.93313 5.26537 6.28585 5.26537 6.66034V10.5577C5.26537 11.298 4.95512 12.0078 4.40554 12.5173L0.14626 16.4799C-0.0487535 16.6628 -0.0487535 16.9633 0.14626 17.1462L11.6831 27.8759C11.8648 28.0414 12.144 28.0414 12.3258 27.8759L18.3091 22.3238C18.5839 22.0669 18.7391 21.7142 18.7391 21.3397H18.7346ZM11.6742 21.3222L6.38227 16.4059C6.10748 16.149 5.95235 15.7963 5.95235 15.4261V12.5956C5.95235 12.2255 6.10748 11.8684 6.38227 11.6159L11.6831 6.68647C11.8648 6.521 12.144 6.521 12.3258 6.68647L17.6177 11.6028C17.8925 11.8597 18.0476 12.2124 18.0476 12.5826V15.4131C18.0476 15.7832 17.8925 16.1403 17.6177 16.3928L12.3169 21.3222C12.1352 21.4877 11.856 21.4877 11.6742 21.3222Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.0162f56a3a479dd19c5e20e5b9998cb3.svg";
export { ForwardRef as ReactComponent };